import { captureException, captureMessage, setTags, setUser, Event } from '@sentry/vue';

export interface SentryEvent {
  locationId: string
  locale: string
  email?: string
  userId?: string
  companyId?: string
}

export const setSentryMeta = (event: SentryEvent) => {
  try {
    setTags({
      locationId: event.locationId,
      locale: event.locale,
      companyId: event.companyId,
    })
    if (event?.email && event?.userId) {
      setUser({ id: event.userId, email: event.email })
    } else {
      setUser({})
    }
  } catch (err) {
    captureMessage(`Issue while setting sentry meta '${err}', please change to use hyphen '-'.`)
  }
}

export const handleFireStoreError = (err: unknown, meta: Record<string, any>) => {
  let errMsg: string
  let error: Error

  if (typeof err === 'string') {
    errMsg = err
    error = new Error(err)
  } else if (err instanceof Error) {
    errMsg = err.message
    error = err
  } else {
    errMsg = 'Login Error: Something went wrong with firebase connection'
    error = new Error(errMsg)
  }

  const tags = {
    ...meta,
    err: errMsg,
    firebaseError: true,
  }

  captureException(error, { tags })
}

export const extractErrorMessageFromOrigException = (originalException: any) => {
  let errorMessage = ''
  const ogException = originalException ?? ''
  if (typeof ogException === 'string') {
    errorMessage += ogException
  } else {
    if (ogException.name) errorMessage += ` name: ${JSON.stringify(ogException.name)};`
    if (ogException.message) errorMessage += ` message: ${JSON.stringify(ogException.message)};`
    if (ogException.stack) errorMessage += ` stack: ${JSON.stringify(ogException.stack)};`
    if (ogException.toString()) errorMessage += ` originalException: ${JSON.stringify(ogException.toString())};`
  }
  return errorMessage
}


//  too many ? is because these are coming from other repos and there is a chance that they might not be there
export const extractFederatedAppMeta = (event: Event) => {
  if (event?.exception?.values?.[0].stacktrace?.frames) {
  const frames = event.exception.values[0].stacktrace.frames
  return frames
    .filter(frame => frame?.module_metadata && frame?.module_metadata?.dsn)
    .map(v => v?.module_metadata)
    .slice(-1)
  } 
return null

}
